export default "__VITE_ASSET__xkgc7W0R__"